"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isURL = exports.theme = exports.getMax = exports.getMin = exports.getBbx = exports.ATILOGO = exports.isMobile = exports.humanize = exports.fetchData = exports.colorScale = exports.iconJSType = exports.percentDiv = exports.screenshot = exports.getOSMTiles = exports.iWithFaName = exports.COLOR_RANGE = exports.colorRanges = exports.shortenName = exports.getCentroid = exports.isStringDate = exports.convertRange = exports.getColorArray = exports.updateHistory = exports.getMainMessage = exports.generateDomain = exports.generateLegend = exports.downloadButton = exports.searchNominatom = exports.colorRangeNames = exports.setGeojsonProps = exports.sortNumericArray = exports.suggestDeckLayer = exports.checkURLReachable = exports.generateDeckLayer = exports.suggestUIforNumber = exports.xyObjectByProperty = exports.uniqueValuePercentage = exports.getParamsFromSearch = exports.firstLastNCharacters = exports.getFirstDateColumnName = exports.getResultsFromGoogleMaps = exports.colorRangeNamesToInterpolate = void 0;

var _react = _interopRequireDefault(require("react"));

var _d3ScaleChromatic = require("d3-scale-chromatic");

var _d3Scale = require("d3-scale");

var _qs = _interopRequireDefault(require("qs"));

var _locationIconMapping = _interopRequireDefault(require("./location-icon-mapping.json"));

var _Constants = _interopRequireDefault(require("./Constants"));

var _JSUtils = require("./JSUtils.js");

var _iconClusterLayer = _interopRequireDefault(require("./icon-cluster-layer"));

var _underscore = require("underscore");

var _csv2geojson = _interopRequireDefault(require("csv2geojson"));

var _d3Array = require("d3-array");

var _locationIconAtlas = _interopRequireDefault(require("./img/location-icon-atlas.png"));

var _geojsonutils = require("./geojsonutils");

var _settingsUtils = require("./components/settings/settingsUtils");

var _history = _interopRequireDefault(require("./history"));

var _link = require("baseui/link");

var _html2canvas = _interopRequireDefault(require("html2canvas"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require("luxon"),
    DateTime = _require.DateTime;

var getResultsFromGoogleMaps = function getResultsFromGoogleMaps(string, callback) {
  if (typeof string === 'string' && typeof callback === 'function') {
    var fullURL = "https://maps.googleapis.com/maps/api/geocode/json?address=" + string + "&key=WRONG_KEY";
    fetch(fullURL).then(function (response) {
      if (response.status !== 200) {
        console.log('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }

      response.json().then(function (data) {
        if (data.results.length === 0 || response.status === 'ZERO_RESULTS') {
          callback(response.status);
        } else {
          callback(data.results[0].geometry.location);
        }
      });
    })["catch"](function (err) {
      console.log('Fetch Error :-S', err);
    });
  }
};

exports.getResultsFromGoogleMaps = getResultsFromGoogleMaps;

var fetchData = function fetchData(url, callback) {
  fetch(url).then(function (response) {
    return response.text();
  }).then(function (response) {
    if (url.endsWith("csv")) {
      _csv2geojson["default"].csv2geojson(response, function (err, data) {
        if (!err) {
          typeof callback === 'function' && callback(data);
        }
      });
    } else {
      try {
        var json = JSON.parse(response);
        callback(json);
      } catch (error) {
        callback(undefined, error);
      }
    }
  })["catch"](function (error) {
    console.error(error);
    callback(null, error);
  });
};

exports.fetchData = fetchData;

var checkURLReachable = function checkURLReachable(URL, callback) {
  fetch(URL).then(function (response) {
    if (response.ok) {
      callback(true);
    } else {
      callback(false);
    }
  })["catch"](function (error) {
    console.log('There has been a problem with your fetch operation: ' + error.message);
  });
};

exports.checkURLReachable = checkURLReachable;

var xyObjectByProperty = function xyObjectByProperty(data, property) {
  var noNulls = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!data || !property) return;
  var map = new Map();
  data.forEach(function (feature) {
    var value = feature.properties[property];

    if (noNulls && (0, _JSUtils.isNullUndefinedNaN)(value)) {
      return;
    }

    value = (0, _JSUtils.isStringNumeric)(value) ? +value : value;

    if (map.get(value)) {
      map.set(value, map.get(value) + 1);
    } else {
      map.set(value, 1);
    }
  });
  var sortedArray = Array.from(map.keys());
  if (!sortedArray || !sortedArray.length) return;
  sortedArray.sort(_d3Array.ascending);
  return sortedArray.map(function (key) {
    return {
      x: key,
      y: +map.get(key)
    };
  });
};

exports.xyObjectByProperty = xyObjectByProperty;
var COLOR_RANGE = (0, _d3Scale.scaleThreshold)().domain([-0.6, -0.45, -0.3, -0.15, 0, 0.15, 0.3, 0.45, 0.6, 0.75, 0.9, 1.05, 1.2]).range([[65, 182, 196], [127, 205, 187], [199, 233, 180], [237, 248, 177], [255, 255, 204], [255, 237, 160], [254, 217, 118], [254, 178, 76], [253, 141, 60], [252, 78, 42], [227, 26, 28], [189, 0, 38], [128, 0, 38]]);
exports.COLOR_RANGE = COLOR_RANGE;

var generateDeckLayer = function generateDeckLayer(name, data, renderTooltip, options) {
  var addOptionsToObject = function addOptionsToObject(opt, obj) {
    Object.keys(opt).forEach(function (key) {
      return obj[key] = opt[key];
    });
  };

  function generateOptions(name, data, renderTooltip) {
    var layerProps = (0, _settingsUtils.getLayerProps)(name);
    if (!layerProps["class"] || !layerProps["class"]["value"]) return null;
    var layerOptions = {};
    Object.keys(layerProps).forEach(function (key) {
      var type = layerProps[key] && layerProps[key].type;

      if (type === 'number' || type === 'column') {
        layerOptions[key] = layerProps[key]["default"];
      } else if (type === 'boolean' || type === 'class') {
        layerOptions[key] = layerProps[key].value;
      } else {
        layerOptions[key] = layerProps[key];
      }
    });
    layerOptions.data = data;
    layerOptions.id = name + "-layer";
    layerOptions.onHover = renderTooltip;

    layerOptions.getPosition = function (d) {
      return d.geometry.coordinates;
    };

    addOptionsToObject(options, layerOptions);
    return new layerProps["class"]["value"](layerOptions);
  }

  if (name === 'icon') {
    var iconObj = {
      id: 'icon-layer',
      data: data,
      pickable: true,
      iconAtlas: _locationIconAtlas["default"],
      iconMapping: _locationIconMapping["default"],
      sizeScale: 60,
      getPosition: function getPosition(d) {
        return d.geometry.coordinates;
      },
      wrapLongitude: true,
      onHover: renderTooltip
    };
    addOptionsToObject(options, iconObj);
    return new _iconClusterLayer["default"](iconObj);
  }

  return generateOptions(name, data, renderTooltip);
};

exports.generateDeckLayer = generateDeckLayer;

var getCentroid = function getCentroid(coords) {
  var center = coords.reduce(function (x, y) {
    return [x[0] + y[0] / coords.length, x[1] + y[1] / coords.length];
  }, [0, 0]);
  center = [parseFloat(center[1].toFixed(3)), parseFloat(center[0].toFixed(3))];
  return center;
};

exports.getCentroid = getCentroid;

var convertRange = function convertRange() {
  var oldValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    oldMax: 10,
    oldMin: 1,
    newMax: 1,
    newMin: 0
  };
  var value = (oldValue - values.oldMin) * (values.newMax - values.newMin) / (values.oldMax - values.oldMin) + values.newMin;
  return +value.toFixed(2);
};

exports.convertRange = convertRange;

var getParamsFromSearch = function getParamsFromSearch(search) {
  if (!search) return null;

  var qsResult = _qs["default"].parse(search.replace("?", ""));

  var lat = Number(qsResult.lat).toFixed(3);
  var lng = Number(qsResult.lng).toFixed(3);
  return {
    latitude: !isNaN(lat) ? Number(lat) : 53.8321,
    longitude: !isNaN(lng) ? Number(lng) : -1.6362,
    zoom: Number(_qs["default"].parse(search).zoom) || 10,
    pit: Number(_qs["default"].parse(search).pit) || 55,
    bea: Number(_qs["default"].parse(search).bea) || 0,
    alt: Number(_qs["default"].parse(search).alt) || 1.5
  };
};

exports.getParamsFromSearch = getParamsFromSearch;

var getBbx = function getBbx(bounds) {
  if (!bounds) return null;
  var xmin = bounds._sw.lng;
  var xmax = bounds._ne.lng;
  var ymin = bounds._sw.lat;
  var ymax = bounds._ne.lat;

  if (xmin > xmax) {
    xmax = bounds._sw.lng;
    xmin = bounds._ne.lng;
  }

  if (ymin > ymax) {
    ymax = bounds._sw.lat;
    ymin = bounds._ne.lat;
  }

  return {
    xmin: xmin,
    ymin: ymin,
    xmax: xmax,
    ymax: ymax
  };
};

exports.getBbx = getBbx;

var suggestDeckLayer = function suggestDeckLayer(features) {
  var r = (0, _JSUtils.randomToNumber)(features && features.length);
  if (!features || !features[r].geometry || !features[r].geometry.type) return null;
  var type = (0, _geojsonutils.sfType)(features[r]);

  if (new RegExp("point", 'i').test(type)) {
    return "grid";
  } else if (new RegExp("line", 'i').test(type)) {
    return "line";
  } else {
    return "geojson";
  }
};

exports.suggestDeckLayer = suggestDeckLayer;

var suggestUIforNumber = function suggestUIforNumber(number) {
  var UI_LIST = _Constants["default"].UI_LIST;
  if (!number) return UI_LIST[1];

  if (number === 1) {
    return UI_LIST[0];
  } else if (number > 3 && number <= 6) {
    return UI_LIST[1];
  } else if (number === 2 || number === 3) {
    return UI_LIST[2];
  } else if (number > 9 && number < 15) {
    return UI_LIST[3];
  } else {
    return UI_LIST[4];
  }
};

exports.suggestUIforNumber = suggestUIforNumber;

var humanize = function humanize(str) {
  if (!str) return str;
  var frags = str.split('_');

  for (var i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }

  return frags.join(' ');
};

exports.humanize = humanize;

var shortenName = function shortenName(name) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 26;

  if ((0, _JSUtils.isNumber)(name)) {
    return parseFloat(Number.parseFloat(name).toFixed(2).toString());
  }

  if (!name || name.length <= n || !(0, _JSUtils.isString)(name)) return name;
  var shortened = name.trim();
  var extension = name.split('.').length > 1 && name.split('.').pop().length < 10 && name.split('.').pop();
  shortened.replace(extension, "");

  if (name.length > 10) {
    shortened = shortened.substring(0, 10) + "..." + (extension || "");
  }

  return shortened;
};

exports.shortenName = shortenName;

var firstLastNCharacters = function firstLastNCharacters(str) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  if (+str || !str) return str;
  return str.slice(0, n) + (str.length > n + n ? "..." + str.slice(str.length - n, str.length) : str.length > n ? "..." : "");
};

exports.firstLastNCharacters = firstLastNCharacters;

var percentDiv = function percentDiv(title, left, cb, dark) {
  return _react["default"].createElement("div", {
    key: title,
    onClick: function onClick() {
      return typeof cb === 'function' && cb();
    },
    style: {
      cursor: 'pointer',
      textAlign: 'center',
      position: 'relative',
      "float": 'left',
      width: '30%',
      color: dark ? 'white' : 'black',
      margin: '10px 2px',
      border: '1px solid gray'
    }
  }, _react["default"].createElement("span", {
    style: {
      position: 'absolute',
      left: '10%'
    }
  }, title), _react["default"].createElement("div", {
    style: {
      width: left + '%',
      height: 20,
      background: 'rgb(18, 147, 154)'
    }
  }));
};

exports.percentDiv = percentDiv;

if (!Array.prototype.flat) {
  Object.defineProperty(Array.prototype, 'flat', {
    value: function value() {
      var depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return this.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten) && depth > 1 ? toFlatten.flat(depth - 1) : toFlatten);
      }, []);
    }
  });
}

var ll = ["http://localhost", "http://127.0.0.1"];
var devURLS = ll.map(function (lh) {
  return [lh, lh + ":8080", lh + ":8000", lh + ":5000", lh + ":3000"];
}).flat();
var urlRegex = new RegExp("^" + "(?:(?:(?:https?|ftp):)?\\/\\/)" + "(?:\\S+(?::\\S*)?@)?" + "(?:" + "(?!(?:10|127)(?:\\.\\d{1,3}){3})" + "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" + "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" + "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" + "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" + "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" + "|" + "(?:" + "(?:" + "[a-z0-9\\u00a1-\\uffff]" + "[a-z0-9\\u00a1-\\uffff_-]{0,62}" + ")?" + "[a-z0-9\\u00a1-\\uffff]\\." + ")+" + "(?:[a-z\\u00a1-\\uffff]{2,}\\.?)?" + ")" + "(?::\\d{2,5})?" + "(?:[/?#]\\S*)?" + "$", "i");

var isURL = function isURL(str) {
  if (!(0, _JSUtils.isString)(str)) return false;
  if ((process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') && devURLS.some(function (e) {
    return str.startsWith(e);
  })) return true;
  return urlRegex.test(str);
};

exports.isURL = isURL;

var isMobile = function isMobile() {
  var check = false;
  if (window.innerWidth < 640) return true;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

exports.isMobile = isMobile;

function hexToRgb(hex) {
  var bigint = parseInt(hex.substring(1, hex.length), 16);
  var r = bigint >> 16 & 255;
  var g = bigint >> 8 & 255;
  var b = bigint & 255;
  return 'rgb(' + r + "," + g + "," + b + ")";
}

var colorScale = function colorScale(v, domain) {
  var alpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 180;
  var colorName = arguments.length > 3 ? arguments[3] : undefined;
  if (!v || !(0, _underscore.isArray)(domain) || !domain.length) return null;
  var index = domain.indexOf(v);
  var d3InterpolateFn = (0, _JSUtils.isString)(colorName) && colorRangeNamesToInterpolate(colorName) ? colorRangeNamesToInterpolate(colorName) : _d3ScaleChromatic.interpolateOrRd;
  var rgb = d3InterpolateFn(index / domain.length);
  rgb = rgb.substring(4, rgb.length - 1).replace(/ /g, '').split(',').map(function (x) {
    return +x;
  });
  return [].concat(_toConsumableArray(rgb), [alpha]);
};

exports.colorScale = colorScale;
var colorRangeNames = ['inverseDefault', 'yellowblue', 'greens', 'oranges', 'diverge', 'default'];
exports.colorRangeNames = colorRangeNames;

var colorRangeNamesToInterpolate = function colorRangeNamesToInterpolate(name) {
  if (!name) return _d3ScaleChromatic.interpolateOrRd;

  if (name === colorRangeNames[0]) {
    return _d3ScaleChromatic.interpolateReds;
  } else if (name === colorRangeNames[1]) {
    return _d3ScaleChromatic.interpolateYlGnBu;
  } else if (name === colorRangeNames[2]) {
    return _d3ScaleChromatic.interpolateGreens;
  } else if (name === colorRangeNames[3]) {
    return _d3ScaleChromatic.interpolateOranges;
  } else if (name === colorRangeNames[4]) {
    return _d3ScaleChromatic.interpolateSinebow;
  } else {
    return _d3ScaleChromatic.interpolateOrRd;
  }
};

exports.colorRangeNamesToInterpolate = colorRangeNamesToInterpolate;

var colorRanges = function colorRanges(name) {
  if (!name) return;
  var colors = {
    yellowblue: [[255, 255, 204], [199, 233, 180], [127, 205, 187], [65, 182, 196], [44, 127, 184], [37, 52, 148]],
    greens: [[237, 248, 233], [199, 233, 192], [161, 217, 155], [116, 196, 118], [49, 163, 84], [0, 109, 44]],
    oranges: [[254, 237, 222], [253, 208, 162], [253, 174, 107], [253, 141, 60], [230, 85, 13], [166, 54, 3]],
    diverge: [[140, 81, 10], [216, 179, 101], [246, 232, 195], [199, 234, 229], [90, 180, 172], [1, 102, 94]],
    inverseDefault: [[189, 0, 38], [240, 59, 32], [253, 141, 60], [254, 178, 76], [254, 217, 118], [255, 255, 178]],
    "default": [[255, 255, 178], [254, 217, 118], [254, 178, 76], [253, 141, 60], [240, 59, 32], [189, 0, 38]]
  };
  return colors[name];
};

exports.colorRanges = colorRanges;

var getColorArray = function getColorArray(name) {
  if (!(0, _JSUtils.isString)(name)) return null;
  var colors = {
    yellowblue: [0, 52, 148],
    greens: [0, 255, 0],
    oranges: [166, 166, 0],
    diverge: [255, 102, 94],
    inverseDefault: [255, 255, 178],
    "default": [189, 0, 38]
  };
  return colors[name];
};

exports.getColorArray = getColorArray;

var iconJSType = function iconJSType(dataType) {
  if (!dataType) return null;

  switch (dataType) {
    case "String":
      dataType = "fa fa-globe";
      break;

    case "Number":
      dataType = "fa fa-list";
      break;

    case "Object":
      dataType = "fa fa-sack";
      break;

    default:
      dataType = "fa fa-question-circle";
  }

  return dataType;
};

exports.iconJSType = iconJSType;

var searchNominatom = function searchNominatom(location, callback) {
  var url = "https://nominatim.openstreetmap.org/search/" + location + "?format=json";
  fetchData(url, function (json) {
    typeof callback === 'function' && callback(json);
  });
};

exports.searchNominatom = searchNominatom;

var ATILOGO = function ATILOGO() {
  var dark = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return _react["default"].createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    id: "ATI_logo_black_ATI_logo_black_W1024px",
    fill: dark ? "#ffffff" : '#000000'
  }, _react["default"].createElement("g", {
    id: "logo-line-1",
    "data-svg-origin": "0.8190000057220459 0.7929999828338623",
    transform: "matrix(1,0,0,1,0,0)",
    style: {
      zIndex: 0,
      visibility: 'inherit',
      opacity: 1
    }
  }, _react["default"].createElement("path", {
    d: "M273.346,71.521 L233.737,71.521 C235.771,58.945 242.738,52.485 253.966,52.485 C265.183,52.485 272.837,60.128 273.346,71.521 M299.694,83.932 C299.694,52.816 282.185,33.27 254.131,33.27 C226.425,33.27 207.72,52.816 207.72,81.718 C207.72,111.985 226.08,131.363 254.983,131.363 C277.938,131.363 293.744,120.479 299.529,100.424 L272.495,100.424 C269.775,107.735 263.987,111.475 255.493,111.475 C242.573,111.475 234.588,103.654 233.902,90.05 L299.529,90.05 C299.694,87.327 299.694,84.948 299.694,83.932",
    id: "Fill-13"
  }), _react["default"].createElement("path", {
    d: "M117.531,128.642 L143.027,128.642 L143.027,83.08 C143.027,63.192 148.647,53.667 160.371,53.667 C171.081,53.667 175.162,59.62 175.162,74.751 L175.162,128.642 L200.658,128.642 L200.658,72.031 C200.658,57.749 198.622,50.437 193.181,44.156 C187.738,37.861 178.392,33.78 169.209,33.78 C159.354,33.78 149.664,38.713 143.027,47.042 L143.027,0.793 L117.531,0.793 L117.531,128.642",
    id: "Fill-12"
  }), _react["default"].createElement("polyline", {
    id: "Fill-11",
    points: "55.645 0.796 0.819 0.796 0.819 23.242 42.3 23.242 42.3 128.632 69.158 128.632 69.158 23.242 110.474 23.242 110.474 0.796 55.645 0.796"
  })), _react["default"].createElement("g", {
    id: "logo-line-2",
    transform: "matrix(1,0,0,1,169,149)",
    "data-svg-origin": "0.9760000109672546 0.0860000029206276",
    style: {
      zIndex: 0,
      visibility: 'inherit',
      opacity: 1
    }
  }, _react["default"].createElement("path", {
    d: "M831.16,79.656 C831.16,94.445 823.69,104.3 812.635,104.3 C801.586,104.3 794.45,94.279 794.45,78.804 C794.45,63.671 801.928,53.308 812.814,53.308 C824.03,53.308 831.16,63.506 831.16,79.656 M855.82,108.724 L855.82,35.289 L832.87,35.289 L832.87,46.848 C825.9,37.158 818.078,33.076 807.029,33.076 C784.253,33.076 768.268,52.112 768.268,78.97 C768.268,106.169 783.222,124.202 805.668,124.202 C817.571,124.202 825.05,120.451 831.85,111.281 L831.85,120.972 C831.85,137.794 826.24,145.106 813.486,145.106 C804.306,145.106 798.025,140.515 797.504,133.382 L772.173,133.382 C773.877,152.076 789.175,163.125 813.145,163.125 C835.42,163.125 849.19,154.121 853.95,136.268 C855.65,129.631 855.82,127.087 855.82,108.724",
    id: "Fill-22"
  }), _react["default"].createElement("path", {
    d: "M701.193,35.283 L676.88,35.283 L676.88,127.932 L702.389,127.932 L702.389,79.994 C702.389,61.465 707.819,52.792 719.557,52.792 C724.997,52.792 729.589,55.349 732.133,59.417 C733.836,62.482 734.346,65.547 734.346,73.534 L734.346,127.932 L759.842,127.932 L759.842,75.402 C759.842,58.91 758.825,52.957 755.085,47.007 C749.476,38.168 739.951,33.249 728.227,33.249 C716.834,33.249 707.144,38.168 701.193,46.841 L701.193,35.283",
    id: "Fill-21"
  }), _react["default"].createElement("path", {
    d: "M637.104,24.567 L662.601,24.567 L662.601,0.088 L637.104,0.088 L637.104,24.567 Z M637.104,127.938 L662.601,127.938 L662.601,35.285 L637.104,35.285 L637.104,127.938 Z",
    id: "Fill-20"
  }), _react["default"].createElement("path", {
    d: "M569.69,127.936 L595.186,127.936 L595.186,86.965 C595.186,64.189 601.991,55.339 619.334,55.339 C622.055,55.339 623.747,55.515 626.467,56.191 L626.467,34.09 C624.089,33.238 622.564,33.073 619.676,33.073 C608.106,33.073 598.926,38.172 594.004,47.352 L594.004,35.286 L569.69,35.286 L569.69,127.936",
    id: "Fill-19"
  }), _react["default"].createElement("path", {
    d: "M532.476,127.936 L556.789,127.936 L556.789,35.286 L531.28,35.286 L531.28,83.225 C531.28,93.259 530.442,98.358 527.884,102.44 C524.822,107.538 519.721,110.424 514.112,110.424 C508.672,110.424 504.08,108.048 501.536,103.798 C499.833,100.737 499.323,97.672 499.323,89.685 L499.323,35.286 L473.827,35.286 L473.827,87.816 C473.827,104.308 474.847,110.259 478.584,116.212 C484.193,125.05 493.883,129.97 505.442,129.97 C516.67,129.97 526.36,125.05 532.476,116.377 L532.476,127.936",
    id: "Fill-18"
  }), _react["default"].createElement("polyline", {
    id: "Fill-17",
    points: "425.87 127.936 452.728 127.936 452.728 22.531 494.041 22.531 494.041 0.086 384.389 0.086 384.389 22.531 425.87 22.531 425.87 127.936"
  }), _react["default"].createElement("path", {
    d: "M287.694,35.283 L263.38,35.283 L263.38,127.932 L288.89,127.932 L288.89,79.994 C288.89,61.465 294.319,52.792 306.057,52.792 C311.498,52.792 316.089,55.349 318.633,59.417 C320.336,62.482 320.846,65.547 320.846,73.534 L320.846,127.932 L346.342,127.932 L346.342,75.402 C346.342,58.91 345.325,52.957 341.585,47.007 C335.977,38.168 326.452,33.249 314.728,33.249 C303.334,33.249 293.644,38.168 287.694,46.841 L287.694,35.283",
    id: "Fill-16"
  }), _react["default"].createElement("path", {
    d: "M226.718,85.77 C226.718,102.428 219.24,111.952 206.144,111.952 C197.991,111.952 192.206,107.364 192.206,101.08 C192.206,93.934 198.501,90.362 214.472,87.818 L223.322,86.456 C223.653,86.28 224.849,86.115 226.718,85.77 M250.687,87.473 C250.852,80.671 250.852,76.59 250.852,74.553 C250.852,57.388 248.818,50.077 241.851,43.272 C235.046,36.305 224.339,32.565 210.912,32.565 C186.088,32.565 170.448,44.468 169.254,64.356 L195.436,64.356 C195.944,55.175 201.221,50.584 211.419,50.584 C221.961,50.584 226.552,56.192 226.718,69.278 C215.5,69.964 200.37,72.177 192.041,74.388 C174.353,78.635 165.68,87.818 165.68,101.92 C165.68,118.413 179.451,129.971 199.353,129.971 C214.307,129.971 223.653,125.049 230.457,113.656 L230.457,117.396 C230.457,120.967 230.623,122.839 231.309,127.937 L253.244,127.937 C251.373,120.116 250.687,110.935 250.687,96.147 L250.687,87.473",
    id: "Fill-15"
  }), _react["default"].createElement("polygon", {
    id: "Fill-14",
    points: "130.939 127.937 156.435 127.937 156.435 0.087 130.939 0.087"
  }), _react["default"].createElement("path", {
    d: "M79.347,73.37 L45.508,73.37 L62.51,20.319 L79.347,73.37 Z M125.075,127.937 L80.529,0.087 L45.343,0.087 L0.976,127.937 L28.341,127.937 L38.541,96.311 L86.659,96.311 L97.024,127.937 L125.075,127.937 Z",
    id: "Fill-1"
  })), _react["default"].createElement("g", {
    id: "logo-line-3",
    transform: "matrix(1,0,0,1,24,297)",
    "data-svg-origin": "0.7670000195503235 0.34700000286102295",
    style: {
      zIndex: 0,
      visibility: 'inherit',
      opacity: 1
    }
  }, _react["default"].createElement("path", {
    d: "M592.476,71.073 L552.866,71.073 C554.9,58.497 561.868,52.037 573.096,52.037 C584.313,52.037 591.966,59.68 592.476,71.073 M618.824,83.484 C618.824,52.368 601.315,32.822 573.261,32.822 C545.552,32.822 526.849,52.368 526.849,81.273 C526.849,111.537 545.21,130.915 574.113,130.915 C597.068,130.915 612.874,120.031 618.659,99.976 L591.625,99.976 C588.902,107.29 583.117,111.028 574.623,111.028 C561.702,111.028 553.718,103.206 553.032,89.602 L618.659,89.602 C618.824,86.879 618.824,84.501 618.824,83.484",
    id: "Fill-10"
  }), _react["default"].createElement("path", {
    d: "M521.303,35.543 L506.348,35.543 L506.348,13.1 L480.839,13.1 L480.839,35.543 L467.246,35.543 L467.246,54.758 L480.839,54.758 L480.839,97.256 C480.839,109.501 481.858,114.765 485.43,120.029 C490.187,127.175 497.168,130.24 508.548,130.24 C513.826,130.24 516.546,129.898 521.303,128.702 L521.303,109.666 C518.238,110.008 517.221,110.173 516.039,110.173 C509.058,110.173 506.348,106.271 506.348,96.236 L506.348,54.758 L521.303,54.758 L521.303,35.543",
    id: "Fill-9"
  }), _react["default"].createElement("path", {
    d: "M434.281,128.196 L458.595,128.196 L458.595,35.546 L433.085,35.546 L433.085,83.485 C433.085,93.52 432.247,98.618 429.69,102.7 C426.625,107.799 421.527,110.684 415.918,110.684 C410.478,110.684 405.886,108.308 403.342,104.061 C401.639,100.997 401.129,97.932 401.129,89.945 L401.129,35.546 L375.633,35.546 L375.633,88.076 C375.633,104.568 376.65,110.519 380.39,116.472 C385.998,125.31 395.689,130.23 407.247,130.23 C418.476,130.23 428.163,125.31 434.281,116.637 L434.281,128.196",
    id: "Fill-8"
  }), _react["default"].createElement("path", {
    d: "M364.433,35.543 L349.479,35.543 L349.479,13.1 L323.969,13.1 L323.969,35.543 L310.376,35.543 L310.376,54.758 L323.969,54.758 L323.969,97.256 C323.969,109.501 324.989,114.765 328.56,120.029 C333.317,127.175 340.298,130.24 351.678,130.24 C356.956,130.24 359.676,129.898 364.433,128.702 L364.433,109.666 C361.368,110.008 360.351,110.173 359.169,110.173 C352.188,110.173 349.479,106.271 349.479,96.236 L349.479,54.758 L364.433,54.758 L364.433,35.543",
    id: "Fill-7"
  }), _react["default"].createElement("path", {
    d: "M288.764,0.347 L276.009,0.347 L276.009,24.823 L301.519,24.823 L301.519,0.347 L288.764,0.347 Z M288.764,35.533 L276.009,35.533 L276.009,128.197 L301.519,128.197 L301.519,35.533 L288.764,35.533 Z",
    id: "Fill-6"
  }), _react["default"].createElement("path", {
    d: "M265.918,35.543 L250.964,35.543 L250.964,13.1 L225.454,13.1 L225.454,35.543 L211.862,35.543 L211.862,54.758 L225.454,54.758 L225.454,97.256 C225.454,109.501 226.474,114.765 230.046,120.029 C234.803,127.175 241.784,130.24 253.164,130.24 C258.441,130.24 261.162,129.898 265.918,128.702 L265.918,109.666 C262.854,110.008 261.837,110.173 260.654,110.173 C253.673,110.173 250.964,106.271 250.964,96.236 L250.964,54.758 L265.918,54.758 L265.918,35.543",
    id: "Fill-5"
  }), _react["default"].createElement("path", {
    d: "M207.476,65.123 C207.641,44.891 193.194,32.825 168.373,32.825 C144.404,32.825 129.105,44.384 129.105,62.238 C129.105,69.029 131.991,75.83 137.092,80.422 C142.877,85.697 148.993,88.076 165.995,91.65 C178.57,94.359 183.162,97.421 183.162,103.209 C183.162,108.638 177.553,112.213 169.059,112.213 C158.341,112.213 152.732,107.111 152.909,97.256 L126.892,97.256 C127.236,118.849 142.367,130.918 168.883,130.918 C194.048,130.918 209.689,119.357 209.689,100.83 C209.689,86.714 201.36,78.209 182.997,73.452 L164.633,68.698 C157.666,66.826 154.601,64.272 154.601,60.19 C154.601,54.581 159.369,51.186 167.356,51.186 C177.719,51.186 181.98,55.091 182.487,65.123 L207.476,65.123",
    id: "Fill-4"
  }), _react["default"].createElement("path", {
    d: "M61.442,35.543 L37.128,35.543 L37.128,128.192 L62.638,128.192 L62.638,80.254 C62.638,61.725 68.068,53.055 79.806,53.055 C85.246,53.055 89.838,55.609 92.381,59.68 C94.085,62.742 94.594,65.807 94.594,73.794 L94.594,128.192 L120.091,128.192 L120.091,75.662 C120.091,59.17 119.074,53.22 115.334,47.267 C109.725,38.428 100.2,33.509 88.476,33.509 C77.083,33.509 67.392,38.428 61.442,47.102 L61.442,35.543",
    id: "Fill-3"
  }), _react["default"].createElement("polyline", {
    id: "Fill-2",
    points: "13.508 0.347 0.767 0.347 0.767 128.197 26.249 128.197 26.249 0.347 13.508 0.347"
  }))));
};

exports.ATILOGO = ATILOGO;

var generateLegend = function generateLegend(options) {
  var domain = options.domain,
      _options$interpolate = options.interpolate,
      interpolate = _options$interpolate === void 0 ? _d3ScaleChromatic.interpolateOrRd : _options$interpolate,
      title = options.title;
  var r = (0, _JSUtils.randomToNumber)(domain && domain.length);
  if (!domain || !Array.isArray(domain) || !(0, _JSUtils.isNumber)(domain[r])) return null;
  var jMax = domain[domain.length - 1],
      jMin = domain[0];
  if (!(0, _JSUtils.isNumber)(jMax) || !(0, _JSUtils.isNumber)(jMin)) return null;
  var legend = [_react["default"].createElement("p", {
    key: "title"
  }, title)];
  var legendMax = domain.length < 10 ? domain.length : 10;

  for (var i = 0; i < legendMax; i += 1) {
    legend.push(_react["default"].createElement(_react["default"].Fragment, null, i === 0 ? _react["default"].createElement("i", null, jMin.toFixed(2)) : i === legendMax - 1 ? _react["default"].createElement("i", null, jMax.toFixed(2)) : _react["default"].createElement("span", {
      key: i,
      style: {
        background: interpolate(i / legendMax)
      }
    })));
  }

  return legend;
};

exports.generateLegend = generateLegend;

var generateDomain = function generateDomain(data, column) {
  if (!data || !Array.isArray(data) || !column || !data.length) return;
  var domainIsNumeric = true;
  var domain = [];
  data.forEach(function (feature) {
    var i = feature.properties[+column ? Object.keys(feature.properties)[column] : column];
    if (!i) return;

    if (+i && column === 'Mean.Travel.Time..Seconds.') {
      domain.push(Math.floor(i / 300));
    } else {
      if (+i) {
        domain.push(+i);
      } else {
        domainIsNumeric = false;
        domain.push(i);
      }
    }
  });
  domain = Array.from(new Set(domain));

  if (domainIsNumeric) {
    domain = domain.sort(function (a, b) {
      return a - b;
    });
  }

  return domain;
};

exports.generateDomain = generateDomain;

var sortNumericArray = function sortNumericArray(array) {
  var domainIsNumeric = true;
  array.map(function (e) {
    return !(0, _JSUtils.isNumber)(e) && (domainIsNumeric = false);
  });

  if (domainIsNumeric) {
    array = array.sort(function (a, b) {
      return a - b;
    });
  }

  return array;
};

exports.sortNumericArray = sortNumericArray;

var getMax = function getMax(arr) {
  return arr.reduce(function (max, v) {
    return max >= v ? max : v;
  }, -Infinity);
};

exports.getMax = getMax;

var getMin = function getMin(arr) {
  return arr.reduce(function (max, v) {
    return max <= v ? max : v;
  }, Infinity);
};

exports.getMin = getMin;

var getOSMTiles = function getOSMTiles(name) {
  var TILES = {
    OSM: "http://tile.openstreetmap.org/{z}/{x}/{y}.png",
    OSMB: "http://b.tile.openstreetmap.org/{z}/{x}/{y}.png",
    TONER: "http://tile.stamen.com/toner/{z}/{x}/{y}.png",
    STAMEN: 'https://stamen-tiles.a.ssl.fastly.net/terrain/{z}/{x}/{y}.jpg'
  };
  return {
    "version": 8,
    "sources": {
      "simple-tiles": {
        "type": "raster",
        "tiles": [TILES[name] || TILES["STAMEN"]],
        "tileSize": 256
      }
    },
    "layers": [{
      "id": "simple-tiles",
      "type": "raster",
      "source": "simple-tiles"
    }]
  };
};

exports.getOSMTiles = getOSMTiles;

var setGeojsonProps = function setGeojsonProps(geojson, data, geoColumn) {
  var dataColumn = geoColumn.split(":")[0];
  var geojsonColumn = geoColumn.split(":")[1] || geoColumn;
  var r = 0;
  var result = Object.assign({}, geojson);
  result.features = [];
  if (!(0, _JSUtils.isObject)(geojson) || !(0, _underscore.isArray)(data) || !(0, _JSUtils.isString)(geoColumn) || !geojson.features || !geojson.features[r] || !geojson.features[r].properties[geojsonColumn] || !data[r] || !data[r].properties || !data[r].properties[dataColumn]) return null;
  geojson.features.forEach(function (feature) {
    for (var i = 0; i < data.length; i++) {
      if (feature.properties[geojsonColumn] === data[i].properties[dataColumn]) {
        var obj = {
          type: feature.type,
          properties: data[i].properties,
          geometry: feature.geometry
        };
        result.features.push(obj);
        break;
      }
    }
  });
  return result;
};

exports.setGeojsonProps = setGeojsonProps;

var getFirstDateColumnName = function getFirstDateColumnName(obj) {
  if (!(0, _JSUtils.isObject)(obj) || !Object.keys(obj)) return null;
  var r = new RegExp(_Constants["default"].DATE_REGEX);
  return Object.keys(obj).filter(function (e) {
    return r.test(e);
  })[0];
};

exports.getFirstDateColumnName = getFirstDateColumnName;

var getMessage = function getMessage(array) {
  return array && array.length && array.length + " row" + (array.length > 1 ? "s" : "");
};

var getMainMessage = function getMainMessage(filtered, unfiltered) {
  if (filtered && filtered.length && unfiltered && unfiltered) {
    return getMessage(filtered) + (filtered.length < unfiltered.length ? " of " + unfiltered.length : "");
  } else if (filtered && filtered.length) {
    return getMessage(filtered);
  } else if (unfiltered && unfiltered.length && !unfiltered[(0, _JSUtils.randomToNumber)(unfiltered.length)].geometry) {
    return getMessage(unfiltered) + " - no geometry";
  } else {
    return "Nothing to show";
  }
};

exports.getMainMessage = getMainMessage;

var theme = function theme(dark) {
  return {
    color: dark ? "white" : "black",
    background: dark ? "#242730" : "white"
  };
};

exports.theme = theme;

var isStringDate = function isStringDate(value) {
  return DateTime.fromFormat(value + '', 'MMMM dd yyyy').isValid || DateTime.fromFormat(value + '', 'MMMM d yyyy').isValid || DateTime.fromFormat(value + '', 'MMM d yyyy').isValid || DateTime.fromFormat(value + '', 'MMM dd yyyy').isValid || DateTime.fromFormat(value + '', 'dd/MM/yyyy').isValid || DateTime.fromFormat(value + '', 'dd-MM-yyyy').isValid || DateTime.fromFormat(value + '', 'yyyy/mm/dd').isValid || DateTime.fromFormat(value + '', 'yyyy-mm-dd').isValid || DateTime.fromISO(value).isValid || DateTime.fromHTTP(value).isValid || _typeof(value) === Number && DateTime.fromMillis(value).isValid;
};

exports.isStringDate = isStringDate;

var arrayCardinality = function arrayCardinality(array) {
  if (!Array.isArray(array) || !array.length) return null;
  return Array.from(new Set(array)).length;
};

var uniqueValuePercentage = function uniqueValuePercentage(array) {
  var test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
  var cardinality = arrayCardinality(array);
  if (!cardinality && cardinality !== 0) return null;
  return cardinality / array.length * 100 > test;
};

exports.uniqueValuePercentage = uniqueValuePercentage;

var updateHistory = function updateHistory(viewport) {
  if (!viewport) return;
  var latitude = viewport.latitude,
      longitude = viewport.longitude,
      zoom = viewport.zoom,
      bearing = viewport.bearing,
      pitch = viewport.pitch,
      altitude = viewport.altitude;
  var search = "?lat=".concat(latitude.toFixed(3)) + "&lng=".concat(longitude.toFixed(3)) + "&zoom=".concat(zoom.toFixed(2)) + "&bea=".concat(bearing) + "&pit=".concat(pitch) + "&alt=".concat(altitude);
  var entry = {
    pathname: _history["default"].location.pathname,
    search: search
  };
  !_history["default"].location.search ? _history["default"].push(entry) : _history["default"].replace(entry);
};

exports.updateHistory = updateHistory;

var downloadButton = function downloadButton(data, name) {
  return _react["default"].createElement(_link.StyledLink, {
    download: name || "tgve-data.geojson",
    href: "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify({
      type: 'FeatureCollection',
      features: data
    }))
  }, _react["default"].createElement("i", {
    style: {
      margin: 5,
      cursor: 'pointer',
      fontSize: '1.5em'
    },
    className: "fa fa-download"
  }));
};

exports.downloadButton = downloadButton;

var screenshot = function screenshot(map, deck) {
  var includeBody = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var fileName = "tgve-screenshot.png";
  console.log("ping");

  if (!map || !deck) {
    return;
  }

  var mapboxCanvas = map.getCanvas();
  deck.redraw(true);
  var deckglCanvas = deck.canvas;
  var canvas = document.createElement("canvas");
  canvas.width = mapboxCanvas.width;
  canvas.height = mapboxCanvas.height;
  var context = canvas.getContext("2d");
  context.globalAlpha = 1.0;
  context.drawImage(mapboxCanvas, 0, 0);
  context.globalAlpha = 1.0;
  context.drawImage(deckglCanvas, 0, 0);

  if (!includeBody) {
    saveCanvas(canvas, fileName);
  } else {
    (0, _html2canvas["default"])(document.body).then(function (htmlCanvas) {
      context.drawImage(htmlCanvas, 0, 0);
      saveCanvas(canvas, fileName);
    });
  }
};

exports.screenshot = screenshot;

var saveCanvas = function saveCanvas(canvas, fileName) {
  var image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
  var link = document.createElement('a');
  link.download = fileName;
  link.href = image;
  link.click();
};

var iWithFaName = function iWithFaName(faName, onClick) {
  return _react["default"].createElement("i", {
    style: {
      margin: 5,
      cursor: 'pointer',
      fontSize: '1.5em'
    },
    onClick: onClick,
    className: faName || "fa fa-info"
  });
};

exports.iWithFaName = iWithFaName;